module.exports = __webpack_public_path__ + "img/kristjan_kangro.6e7bee02.jpeg";